// packages/content/src/tuning/fishing.ts
import type { TuningBank } from '../schema/tuning';
export default {
  windowMs: 600, latencyAllowanceMs: 1500, earlyGraceMs: 150, nibbles: [0, 3], approachMs: [900, 2200],
  nibbleGapMs: [500, 1100], castRange: 5, shadowRange: 1.5, shadowsPerArea: { river: 4, pond: 2, sea: 5 },
  rarityWeights: [40, 25, 15, 7, 3], sizeJitter: 0.2, newsRarity: 4,
} as const satisfies TuningBank;
